<template>
  <div style="overflow: auto">
    <span
      v-html="
        transformHtml(
          convertAnswerText(
            row.questionDetails && (row.questionDetails.content.richText || row.questionDetails.content.text),
            answerContent
          )
        )
      "
    >
    </span>
    <show-files v-if="row && row.activePhotoFiles" :img-data="row.activePhotoFiles"></show-files>
    <!-- <div v-if="scope.row && scope.row.questionDetails && scope.row.questionDetails.content && scope.row.questionDetails.content.image">
      <el-image
        v-for="(item,index) in scope.row.questionDetails.content.image"
        :key="index"
        style="width: 30px; height: 30px;"
        :z-index="5000"
        :src="_getDownloadUrl(item.url)"
        :preview-src-list="getDownloadList(scope.row.questionDetails.content.image)"
      />
    </div> -->
  </div>
</template>

<script>
// 题干显示组件
import ShowFiles from './ShowFiles.vue'
import { convertAnswerText } from '@/question/convert.js'
import { transformHtml } from '@/components/survey-detail/utils/index.js'
export default {
  components: { ShowFiles },
  props: {
    row: {
      type: Object
    },
    answerContent: {
      type: Array
    }
  },
  methods: {
    convertAnswerText,
    transformHtml
  }
}
</script>
